import { atom } from "jotai";
import { nodesAtom } from "../nodes";

export const showActiveAnnotationNodeSetter = atom(
  null,
  (_, set, activeStepNumber: number | null) => {
    set(nodesAtom, (prevNodes) =>
      prevNodes.map((node) => ({
        ...node,
        hidden:
          node.type === "annotation"
            ? activeStepNumber === null
              ? true
              : node.data.stepNumber !== activeStepNumber
            : node.hidden,
      })),
    );
  },
);

showActiveAnnotationNodeSetter.debugLabel = "showActiveAnnotationNodeSetter";
